module.exports = __webpack_public_path__ + "static/media/rng-5.6cfbad00.gif";